/**
 * Selection target of the Space records page.
 *
 * The same target scopes the selected records on the records collection and,
 * during cluster assignment, the selected cluster on the clusters collection.
 */
export const SPACE_RECORDS_SELECTION_TARGET = 'SpaceRecords.Selection'
